<template>
    <div>
        <!--<div class="text-center my-3">-->
        <!--<b-btn v-b-tooltip.hover title="I'm a tooltip!">Hover Me</b-btn>-->
        <!--</div>-->
        <form role="form">
            <div class="row">
                <div class="col-md-6">

                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">Données de la formation / de l'examen</h3>
                            <button type="button"
                                    class="btn btn-xs btn-danger btn-flat margin pull-right"
                                    style="margin-top: 0;margin-bottom: 0;"
                                    @click="supprimerFormation()"
                            >
                                Supprimer la formation / l'examen
                            </button>
                        </div>

                        <div class="box-body">
                            <div class="form-group"
                                 :class="{'has-error': errors.has('formation[titre]') }">
                                <label for="titre">Titre de la formation</label>
                                <input type="text" class="form-control" id="titre" name="formation[titre]"
                                       v-validate="'max:200'"
                                       placeholder="Nom de la formation/de l'examen" v-model="getFormation.titre">
                                <span v-show="errors.has('formation[titre]')" class="help-block">Le titre de la formation/de l'examen doit comporter moins de 200 caractères</span>
                            </div>

                            <div class="form-group"
                                 :class="{'has-error': errors.has('formation[date]') }">
                                <label>Date de la formation / de l'examen</label>
                                <div class="input-group date">
                                    <div class="input-group-addon">
                                        <i class="fa fa-calendar"></i>
                                    </div>
                                    <masked-input type="text"
                                                  v-model="getFormation.dateFR"
                                                  v-validate="'required|date_format:DD/MM/YYYY'"
                                                  :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                                  :guide="true"
                                                  :keepCharPositions="true"
                                                  :showMask="true"
                                                  name="formation[date]"
                                                  class="form-control pull-right datepicker"
                                                  id="datepicker2">
                                    </masked-input>
                                </div>
                                <span v-show="errors.has('formation[date]')"
                                      class="help-block">Date incorrecte</span>
                            </div>

                            <div class="form-group"
                                 :class="{'has-error': errors.has('formation[adresse]') }">
                                <label for="adresse">Adresse</label>
                                <textarea type="text" class="form-control" id="adresse" name="formation[adresse]"
                                          placeholder="Adresse"
                                          v-model="getFormation.adresse">{{getFormation.adresse}}</textarea>
                            </div>

                            <div class="form-group">
                                <label for="statut">Type de formation/examen</label>
                                <select id="statut" class="form-control" name="formation[type]" v-model="getFormation.idType">
                                    <option value="19">Aucun/indéterminé</option>
                                    <optgroup label="Grade">
                                        <option
                                                v-for="type in getTypeByType('grade')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="Arbitre technique">
                                        <option
                                                v-for="type in getTypeByType('arbitre_tech')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="Arbitre combat">
                                        <option
                                                v-for="type in getTypeByType('arbitre_cbt')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>

                                    <optgroup label="Divers">
                                        <option
                                                v-for="type in getTypeByType('divers')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="ADEPS">
                                        <option
                                                v-for="type in getTypeByType('adeps')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="ABFT">
                                        <option
                                                v-for="type in getTypeByType('abft')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="Hapkido">
                                        <option
                                                v-for="type in getTypeByType('hpk')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="Tangsoodo">
                                        <option
                                                v-for="type in getTypeByType('tng')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="Haedong Kumdo">
                                        <option
                                                v-for="type in getTypeByType('hdkd')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="ETU">
                                        <option
                                                v-for="type in getTypeByType('ETU')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>
                                    <optgroup label="WT (WTF)">
                                        <option
                                                v-for="type in getTypeByType('WTF')"
                                                :value="type.id"
                                        >{{type.type}}
                                        </option>
                                    </optgroup>

                                </select>
                            </div>

                            <div class="form-group">
                                <label for="statut">Formation/examen lié</label>
                                <select id="formationlie" class="form-control" name="formation[idFormationExamen]"
                                        v-model="getFormation.idFormationExamen">
                                    <option value="0">Aucun</option>
                                    <option
                                            v-for="formation in getListeFormation"
                                            :value="formation.id"
                                            v-if="formation.id!=getFormation.id"
                                    >
                                        {{formation.titre}}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group"
                                 :class="{'has-error': errors.has('formation[comments]') }">
                                <label for="adresse">Commentaires</label>
                                <textarea type="text" class="form-control" id="comments" name="formation[comments]"
                                          placeholder="Commentaires éventuels"
                                          v-model="getFormation.comments">{{getFormation.comments}}</textarea>
                            </div>

                            <div class="form-group">
                                <div class="checkbox">
                                    <label for="cours_generaux">
                                        <input id="cours_generaux" name="formation[cours_generaux]" type="checkbox"
                                               v-model="getFormation.cours_generaux">
                                        Cours généraux ?
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="box box-primary"
                         v-if="getFormation.id && getFormation.inscriptions && getFormation.inscriptions.length > 0">
                        <div class="overlay" v-if="loadingSecretariatBox">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                        <div class="box-header with-border">
                            <h3 class="box-title">Secrétariat</h3>
                        </div>
                        <div class="box-body">
                            <a :href="mailToAllMembers()" class="btn btn-primary margin">Envoyer un mail à tous les membres</a>
                            <a :href="mailToAllSucceed()" :disabled="!formationHasSucceed()" class="btn btn-primary margin">Envoyer un mail aux réussites</a>
                            <a :href="mailToAllFailed()" :disabled="!formationHasFailed()" class="btn btn-primary margin">Envoyer un mail aux échecs</a>
                            <a @click.prevent="exportEtiquettes()" class="btn btn-primary margin">Imprimer les étiquettes</a>
                            <a @click.prevent="exportCartesAnnuelles()" class="btn btn-primary margin">Imprimer les cartes annuelles</a>
                            <a @click.prevent="exportForPublipostage()" class="btn btn-primary margin">Fichier pour le publipostage</a>
                            <a @click.prevent="printEtiquetteEnvoi()" class="btn btn-primary margin">Imprimer les étiquettes d'envoi</a>
                            <a @click.prevent="exportFacturesXls()" class="btn btn-primary margin">Exporter la facture (XLS)</a>
                        </div>
                    </div>
                    <div class="box box-primary">
                        <div class="box-header with-border">
                            <h3 class="box-title">Membres inscrits à la formation/à l'examen</h3>
                        </div>
                        <div class="box-body">
                            <div class="overlay" v-if="isTableMembresLoading() || loadingTable">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>

                            <div v-if="!isTableMembresLoading() && !loadingTable">
                                <b-table responsive bordered striped hover
                                         :items="getFormation.inscriptions"
                                         :fields="columnsMembres"
                                         :per-page="perPage"
                                         :current-page="currentPage"
                                         :empty-text="'Aucun résultat'"
                                         :empty-filtered-text="'Aucun résultat'"
                                         foot-clone
                                         show-empty
                                >
                                    <template slot="actions" slot-scope="row">
                                        <router-link
                                                class="btn btn-default padding2"
                                                :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                                            <i class="glyphicon glyphicon-pencil"></i>
                                        </router-link>
                                        <a href="#" @click.prevent="removeMembre(row.item.id)"
                                           class="btn btn-default padding2">
                                            <i class="glyphicon glyphicon-remove"></i>
                                        </a>
                                    </template>
                                    <template slot="id" slot-scope="data">
                                        {{data.item.id | idFormat}}
                                    </template>
                                    <template slot="nom" slot-scope="data">
                                        <router-link
                                                :to="{ name: 'Member', params: { member_id: data.item.membre.id }}">
                                            {{data.item.membre.fullName}}
                                        </router-link>
                                    </template>
                                    <template slot="montant" slot-scope="data">
                                        {{data.item.montant}}€
                                    </template>
                                    <template slot="FOOT_montant" slot-scope="foo">
                                        <strong>{{getFormation.total}}€</strong>
                                    </template>
                                    <template slot="FOOT_actions" slot-scope="foo"></template>
                                </b-table>
                                <b-pagination size="md"
                                              :total-rows="getFormation.inscriptions.length"
                                              v-model="currentPage"
                                              :per-page="perPage">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="box ">
                        <div class="overlay"
                             v-if="this.disabledBtn">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                        <div class="box-body">
                        </div>
                        <div class="box-footer">
                            <button type="button"
                                    class="btn btn-lg btn-primary btn-flat margin pull-right"
                                    :disabled="errors.count()!=0 || this.disabledBtn || this.loadingInputs.length>0"
                                    @click="sendForm()">
                                Enregistrer les modifications
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';
    import vSelect from '../../Communs/vSelect/index'

    var $ = require('jquery');
    var variables = require('../../../assets/js/variables')
    var _ = require('underscore')
    var moment = require('moment')
    var FileSaver = require('file-saver');

    export default {
        props: {
            loadingTableMembres: {
                required: true,
                'default': false
            },
        },
        data() {
            return {
                loadingInputs: [],
                disabledBtn: false,
                resize: false,
                loadingTable: false,
                activeTab: "default",
                redraw: "",
                loadingSecretariatBox: false,
                loadingMembres: false,
                licencesMembres: [],
                currentPage: 1,
                perPage: 10,
                columnsMembres: [
                    {
                        label: 'Num. Inscription',
                        key: 'id',
                        sortable: true,
                    },
                    {
                        label: 'Nom',
                        key: 'nom',
                        sortable: true,
                    },
                    {
                        label: 'Montant',
                        key: 'montant',
                        sortable: true,
                    },
                    {
                        label: 'Actions',
                        key: 'actions',
                    },
                ],
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getListeFormation: 'getListeFormation',
                getTypesFormation: 'getTypesFormation',
                getFormation: 'getFormation'
            }),
        },
        mounted: function () {
            var these = this
        },
        created() {
            this.getTableMembres();

        },
        beforeRouteEnter(to, from, next) {
            this.getTableMembres();
            next()
        },
        watch: {},
        components: {
            vSelect,
        },
        methods: {
            ...mapActions({
                setFormation: 'setFormation',
            }),
            getTypeByType: function (typeSearched) {
                let retour = [];
                this.getTypesFormation.forEach(function (item) {
                    if (item.meta == typeSearched)
                        retour.push(item);
                });
                return _.sortBy(retour, function (item) {
                    return item.order;
                });
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
            currentYear: function () {
                return moment().year();
            },
            getTableMembres: function () {
                this.loadingMembres = true;
            },
            isTableMembresLoading: function (force = false) {
                if (force)
                    return true
                return this.loadingTableMembres;
            },
            printEtiquetteEnvoi: function () {
                let these = this;
                this.loadingSecretariatBox = true
                this.$http.post
                (
                    this.getRoute('Secretariat.etiquetteEnvoiMembre'),
                    JSON.stringify({"id_formation": this.getFormation.id}),
                    {responseType: 'blob'}
                ).then(function (response) {
                    var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
                    FileSaver.saveAs(blob, these.getFormation.id + "_etiquettes.pdf");
                    this.loadingSecretariatBox = false
                    return response.blob();
                }, (response) => {
                    this.loadingSecretariatBox = false
                    these.$noty.error("Erreur dans la génération des étiquettes")
                });
            },
            exportFacturesXls: function () {
                let these = this;
                this.loadingSecretariatBox = true
                this.$http.post
                (
                    this.getRoute('Secretariat.exportFactureFormation'),
                    JSON.stringify({"id_formation": this.getFormation.id}),
                    {responseType: 'blob'}
                ).then(function (response) {
                    var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
                    FileSaver.saveAs(blob, these.getFormation.id + "_factures.xls");
                    this.loadingSecretariatBox = false
                    return response.blob();
                }, (response) => {
                    this.loadingSecretariatBox = false
                    these.$noty.error("Erreur dans la génération de la facture")
                });
            },

            exportEtiquettes: function () {
                if (!this.getFormation.id || !this.getFormation.inscriptions || this.getFormation.inscriptions.length <= 0)
                    return;
                this.loadingSecretariatBox = true
                let these = this;
                this.$http.post
                (
                    this.getRoute('Secretariat.etiquetteIndividuelleMembre'),
                    JSON.stringify({"id_formation": these.getFormation.id}),
                    {responseType: 'blob'}
                ).then(function (response) {
                    this.loadingSecretariatBox = false
                    var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
                    FileSaver.saveAs(blob, these.getFormation.id + "_etiquettes.pdf");
                    return response.blob();
                }, (response) => {
                    these.$noty.error("Erreur dans la génération des étiquettes")
                    this.loadingSecretariatBox = false
                });
            },

            exportCartesAnnuelles: function (qrCode = true) {
                let these = this;

                if (!this.getFormation.id || !this.getFormation.inscriptions || this.getFormation.inscriptions.length <= 0) {
                    these.$noty.error("Erreur dans la génération des cartes")
                    return;
                }

                this.loadingSecretariatBox = true
                let route = qrCode ? 'Secretariat.carteAnnuelleMembreQrcode' : 'Secretariat.carteAnnuelleMembre'

                this.$http.post
                (
                    these.getRoute(route),
                    JSON.stringify({"id_formation": these.getFormation.id}),
                    {responseType: 'blob'}
                ).then(function (response) {
                    these.loadingSecretariatBox = false
                    var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
                    FileSaver.saveAs(blob, these.getFormation.id + "_licences.pdf");
                    return response.blob();
                }, (response) => {
                    these.$noty.error("Erreur dans la génération des cartes")
                    these.loadingSecretariatBox = false
                });
            },

            removeMembre: function (id) {
                let self = this;
                this.isBusy = true
                this.loadingTable = true
                this.$http.post(this.getRoute('Secretariat.formation.deleteInscription'), {id: id}).then(function (response) {
                    self.$noty.success("L'inscription a bien été supprimée")
                    this.disabledBtn = false
                    this.isBusy = false
                    this.loadingTable = false
                    this.setFormation(response.body)
                    this.getFormation.inscriptions = _.reject(this.getFormation.inscriptions, function (item) {
                        return item.id == id;
                    });
                }, (response) => {
                    this.isBusy = false
                    self.$noty.error("Erreur dans la modification de l'inscription")
                    this.loadingTable = false
                    this.disabledBtn = false
                });
            },
            constructMail: function (key) {
                return "mailto:" + (this.getTextesRecap[key].to ? this.getTextesRecap[key].to + '?' : "?") +
                    "subject=" + this.getTextesRecap[key].subject +
                    (this.getTextesRecap[key].cc ? "&cc=" + this.getTextesRecap[key].cc : "") +
                    (this.getTextesRecap[key].cci ? "&bcc=" + this.getTextesRecap[key].cci : "")
            },
            constructForm: function () {
                return JSON.stringify({
                    "titre": this.getFormation.titre,
                    "date": this.formatDate(this.getFormation.dateFR, "DD/MM/YYYY", "YYYY-MM-DD"),
                    "adresse": this.getFormation.adresse,
                    "idType": this.getFormation.idType,
                    "idFormationExamen": this.getFormation.idFormationExamen,
                    "cours_generaux": this.getFormation.cours_generaux,
                    "comments": this.getFormation.comments,
                })
            },
            supprimerFormation: function () {
                let these = this
                let self = this
                this.$dialog.confirm('' +
                    'Confirmez-vous la suppression de la formation / l\'examen ?<br/><br/> ' +
                    'Toutes les inscriptions à cette formations seront supprimées également. ',
                    {
                        html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
                        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
                        reverse: false, // switch the button positions (left to right, and vise versa)
                        okText: 'Suppr. la formation / examen',
                        cancelText: 'Annuler',
                        animation: 'zoom', // Available: "zoom", "bounce", "fade"
                        type: 'basic', // coming soon: 'soft', 'hard'
                    })
                    .then(function (dialog) {
                        setTimeout(() => {
                            self.$http.post(self.getRoute('Secretariat.formation.delete'), {id_formation: self.getFormation.id})
                                .then(function (response) {
                                    self.$noty.success("Formation/examen supprimé")
                                    self.$router.push('/');
                                    dialog.close();
                                }, (response) => {
                                    self.$noty.success("Erreur dans la suppression")
                                    dialog.close();
                                });
                        }, 1000);
                    })
                    .catch(function () {
                        // console.log('Clicked on cancel')
                    });
            },
            sendForm: function () {
                this.disabledBtn = true;
                let self = this;
                this.$http.put(this.getRoute('Secretariat.formation.update') + this.getFormation.id, this.constructForm()).then(function (response) {
                    self.$noty.success("Le formation / examen a bien été modifié")
                    this.disabledBtn = false
                }, (response) => {
                    self.$noty.error("Erreur dans la sauvegarde du formation / examen")
                    this.disabledBtn = false
                });
            },
            isInputLoading: function (input) {
                return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
            },
            addToLoadingInputs: function (input) {
                this.loadingInputs.push(input)
            },
            removeFromLoadingInputs: function (input) {
                this.loadingInputs = _.without(this.loadingInputs, input)
            },
            mailToAllMembers: function (membresPreSelect = null) {
                if (membresPreSelect == null)
                    membresPreSelect = this.getFormation.membres

                let mails = "mailto:";
                membresPreSelect.forEach(function (item) {
                    mails = mails + item.mail + ";"
                })
                return mails;
            },
            mailToAllSucceed: function () {
                if (!this.formationHasSucceed())
                    return null;

                let idsMembre = [];
                let membres = [];
                this.getFormation.inscriptions.forEach(function (item) {
                    if (item.reussite)
                        idsMembre.push(item.idMembre)
                })
                this.getFormation.membres.forEach(function (item) {
                    if (idsMembre.includes(item.id))
                        membres.push(item);
                })
                return this.mailToAllMembers(membres);
            },
            mailToAllFailed: function () {
                if (!this.formationHasFailed())
                    return null;

                let idsMembre = [];
                let membres = [];
                this.getFormation.inscriptions.forEach(function (item) {
                    if (!item.reussite)
                        idsMembre.push(item.idMembre)
                })
                this.getFormation.membres.forEach(function (item) {
                    if (idsMembre.includes(item.id))
                        membres.push(item);
                })
                return this.mailToAllMembers(membres);
            },
            formationHasSucceed: function () {
                let found = false
                this.getFormation.inscriptions.forEach(function (item) {
                    if (item.reussite)
                        found = true
                })
                return found;
            },
            formationHasFailed: function () {
                let found = false
                this.getFormation.inscriptions.forEach(function (item) {
                    if (!item.reussite)
                        found = true
                })
                return found;
            },
            exportForPublipostage: function () {
                let these = this;

                if (!this.getFormation.id || !this.getFormation.inscriptions || this.getFormation.inscriptions.length <= 0) {
                    these.$noty.error("Erreur dans la génération des cartes")
                    return;
                }
                this.loadingSecretariatBox = true
                this.$http.post
                (
                    these.getRoute('Secretariat.recapitulatif.exportFormationPublipostage'),
                    JSON.stringify({"id_formation": these.getFormation.id}),
                    {responseType: 'blob'}
                ).then(function (response) {
                    these.loadingSecretariatBox = false
                    var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
                    FileSaver.saveAs(blob, these.getFormation.id + "_publipostage.txt");
                    return response.blob();
                }, (response) => {
                    these.$noty.error("Erreur dans la génération du publipostage")
                    these.loadingSecretariatBox = false
                });
            }
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Formation/MainFormFormation.vue